import { createTheme } from '@mui/material/styles';
import merge from 'lodash/merge';
import { defaultTheme } from 'react-admin';

import { sidebarWidth } from './layout';
import { palette } from './palette';
import { statusColors } from './statusColors';

export const baseTheme = createTheme(
  merge({}, defaultTheme, {
    shadows: Array(25).fill('none'),
    sidebar: { width: sidebarWidth },

    palette: {
      ...palette,
      status: statusColors,
    },
  }),
);
